import { Outlet } from "react-router-dom";
import HeadLayout from "@shared/layouts/HeadLayout";
import { useTranslation } from "react-i18next";

const Invoices = () => {
  const { t } = useTranslation();
  return (
    <>
      <HeadLayout title={t("navigation.invoices")} />
      <Outlet />
    </>
  );
};

export default Invoices;
